import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { BasicService, RoutePaths } from '../shared/services/basic.service';
import { TaskService } from '../shared/services/task.service';

@Injectable({
  providedIn: 'root',
})
export class AcquireBeforeProcessingGuard implements CanActivate {
  constructor(private basicService: BasicService, private taskService: TaskService, private route: ActivatedRoute) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const taskId = Number(next.params.taskId);
    const currentTaskState = next.queryParams['current-task-state'] || 'pending';

    // If we are in CRM mode we don't want to acquire the task each time we open the case
    if (next.data.isCRMMode) {
      return of(true);
    } else {
      return this.taskService.acquireTask(taskId, currentTaskState).pipe(
        map(() => true),
        catchError(() => this.handleAcquireError(next.data.isCRMMode))
      );
    }

    // the router will subscribe to the returned Observable
  }

  /**
   * In CRM mode, we haven't navigated anywhere yet,
   * hence to prevent the user seeing just a white page,
   * we navigate to a page containing an alcmeon logo.
   * In normal mode, we'll just stay on the tasks list page
   */
  private handleAcquireError(isCRMMode: boolean): Observable<boolean> {
    if (isCRMMode) {
      this.basicService.navigateRoot(RoutePaths.CulDeSac, { queryParams: { showLogo: true } });
    } else if (!this.route.snapshot.component) {
      // This can be the case if the app starts from a push notif but sill has a valid jwt
      console.warn('AcquireBeforeProcessingGuard - we havent navigated anywhere yet, navigating to the task list');
      this.basicService.navigateRoot(RoutePaths.TasksListsTabs);
    }
    return of(false);
  }
}
